'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderBackgroundContainerStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderBackgroundContainerStyled = exports.HeaderBackgroundContainerStyled = _styledComponents2.default.div.withConfig({
  displayName: 'HeaderBackgroundContainerStyled'
})(['position:absolute;width:100%;height:100%;top:0;left:0;z-index:0;background-size:cover;background-position:center;background-repeat:no-repeat;']);

HeaderBackgroundContainerStyled.displayName = 'HeaderBackgroundContainerStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-header/dist/styles/HeaderBackgroundContainerStyled.js
// module id = 703
// module chunks = 0